<template>
  <cube-page title="省区销售">
    <div slot="content" style="background-color: white">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        :stretch="true"
      >
        <el-tab-pane label="全年进度排名" name="top"> </el-tab-pane>
        <el-tab-pane label="明细数据" name="detail"> </el-tab-pane>
      </el-tabs>
      <wmq-layout
        v-show="activeName === 'top'"
        ref="top"
        :rootLayoutConfig="topUiConfig"
      />
      <wmq-layout
        v-show="activeName === 'detail'"
        ref="detail"
        :rootLayoutConfig="detailConfig"
      />
    </div>
  </cube-page>
</template>

<script>
import uiConfig from '@/config/ui-config/province-sales-detail-ui-config'
import topUiConfig from '@/config/ui-config/province-sales-top-ui-config'
import { biData } from '@/api/cube'
import { WmqDashboardCubeDataHelperMixin, CubeDataHandle } from 'wmq-component'
import { get, set } from 'lodash'
import CubePage from '../../components/cube-page'
export default {
  name: 'ProvinceSales',
  components: { CubePage },
  mixins: [WmqDashboardCubeDataHelperMixin],
  data () {
    return {
      activeName: 'top',
      topUiConfig
    }
  },
  mounted () {
    this.$refs[this.activeName].refreshAll()
  },
  provide () {
    const that = this
    return {
      requestHandler: function (data, reqObj) {
        if (get(reqObj, 'date') === '__date__') {
          reqObj.date = that.$route.query.date
        }
        return biData(data.dataCode, reqObj).then((res) => {
          return new Promise((resolve) => {
            resolve(CubeDataHandle.handleCubeData(res.data))
          })
        })
      }
    }
  },
  computed: {
    detailConfig () {
      const height = document.body.clientHeight - 100
      set(uiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return uiConfig
    }
  },
  methods: {
    pushUserLog (text) {
      // 上报操作日志
      this.$store.dispatch('PushUserLog', {
        menu: '全国分析',
        page: '省区销售',
        operation: '切换Tab'
      })
    },
    handleClick () {
      this.$refs[this.activeName].refreshAll()
      this.pushUserLog()
    }
  }
}
</script>

<style scoped></style>
